import { observer } from 'mobx-react-lite'
import { type CreateJobConfirmationDialogViewModel } from './CreateJobConfirmationDialogViewModel'
import { CreateJobConfirmationDialog } from '@/features/call-center/CreateJobConfirmationDialog'

export interface CreateJobConfirmationDialogContainerProps {
  vm: CreateJobConfirmationDialogViewModel
}

export const CreateJobConfirmationDialogContainer = observer(
  function CreateJobConfirmationDialogContainer({
    vm,
  }: CreateJobConfirmationDialogContainerProps) {
    return (
      <CreateJobConfirmationDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        memberName={vm.memberName}
        workspaceName={vm.workspaceName}
        confirmationInput={vm.confirmationInput}
        onConfirmationInputChange={vm.setInput}
        canConfirm={vm.canConfirm}
        isPending={vm.confirm.pending}
        onConfirm={vm.confirm}
      />
    )
  },
)
